export default {
  form: {
    address: {
      label: 'Adres',
      placeholder: 'Adres',
    },
    zip_code: {
      label: 'Kod pocztowy',
      placeholder: 'Kod pocztowy',
    },
    city: {
      label: 'Miasto',
      placeholder: 'Miasto',
    },
    start_time: {
      label: 'Godzina rozpoczęcia',
      placeholder: 'np. 11:00',
    },
    name: {
      label: 'Nazwa lokalizacji (opcjonalnie)',
      placeholder: 'np. Obok Fernsehturm',
      tooltip: 'Podanie nazwy lokalizacji może pomóc klientom ją zidentyfikować, np. „Obok Fernsehturm"',
    },
    note: {
      label: 'Uwaga',
      placeholder: 'Wpisz uwagę',
    },
  },
  buttons: {
    add_location: 'Dodaj lokalizację',
  },
};
